export const OPTIONS = Array.from({ length: 30 }, (_, i) => ({
  value: `${i + 1}`,
  label: `${i + 1}`,
}));
export const SORT_OPTIONS = [
  { value: "new", label: "New to Old" },
  { value: "old", label: "Old to New" },
  { value: "high", label: "Price Hight to Low" },
  { value: "low", label: "Price Low to High" },
];
export const PURPOSE_OPTIONS = [
  { value: "self occupied", label: "Self occupied " },
  { value: "investment", label: "Investment" },
];
export const SOURCE_OPTIONS = [
  { value: "Property Manage", label: "Property Manage " },
  { value: "Lead", label: "Lead" },
  { value: "Site Visit", label: "Site Visit" },
];
export const LEAD_TYPE_OPTIONS = [
  { value: "Property", label: "Property" },
  { value: "Project", label: "Project" },
  { value: "Villa", label: "Villa " },
];
export const FURNISHED_OPTIONS = [
  { value: "furnished", label: "Furnished" },
  { value: "unfurnished", label: "Unfurnished" },
  { value: "semifurnished", label: "Semi Furnished" },
];
export const LEAD_STATUS_OPTIONS = [
  { value: "All", label: "All Leads" },
  { value: 1, label: "Pending Leads" },
  { value: 2, label: "Converted Leads" },
  { value: 3, label: "Succeed Leads" },
  { value: 4, label: "Rejected Leads" },
];
export const REFERRED_BY_OPTIONS = [
  { value: "Admin", label: "Admin" },
  { value: "Broker / Channel Partners", label: "Broker / Channel Partners" },
  { value: "Owner / Sellers", label: "Owner / Sellers" },
  { value: "Builders / Developers", label: "Builders / Developers" },
];
